import { lazy, Suspense } from 'react';
import Fallback from '../custom/fallback/fallback';
import DashboardLayout from "./dashboardLayout/dashboardLayout";
const Main = lazy(() => import('../components/contactUs/main'))

const ContactUs = () => {
    return (
        <DashboardLayout 
            heading="Contact Us"
            paragraph="For enquiries or complaints please reach out for a quick response.">
            <Suspense fallback={<Fallback />}>
                <Main />
            </Suspense>
        </DashboardLayout>
    );
};

export default ContactUs;